var _style, _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFaqWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "faq-white_svg__Layer_1",
    x: 0,
    y: 0,
    viewBox: "0 0 1024 1024",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".faq-white_svg__st8{fill:#fff}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M928.2 243.5c.6 1 1.3 1.9 1.9 2.9-.6-1-1.3-1.9-1.9-2.9zM873.4 278.6c.9 1.6 1.9 3.2 3.1 4.6-.8-1.3-1.6-2.5-2.5-3.8-.2-.2-.4-.5-.6-.8zM782.9 100.2c1.9 1.2 3.7 2.4 5.6 3.7-1.7-1.4-3.6-2.6-5.6-3.7z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M512 85.4c58.7 0 115.6 11.5 169.1 34.1 51.7 21.9 98.2 53.2 138.1 93.2 39.9 39.9 71.3 86.4 93.2 138.1 22.6 53.5 34.1 110.4 34.1 169.1S935 635.5 912.4 689c-21.9 51.7-53.2 98.2-93.2 138.1-39.9 39.9-86.4 71.3-138.1 93.2-53.5 22.7-110.4 34.2-169.1 34.2S396.4 943 342.9 920.4c-51.7-21.9-98.2-53.2-138.1-93.2-39.9-39.9-71.3-86.4-93.2-138.1C89 635.6 77.5 578.7 77.5 520S89 404.4 111.6 350.9c21.9-51.7 53.2-98.2 93.2-138.1 39.9-39.9 86.4-71.3 138.1-93.2C396.4 96.9 453.3 85.4 512 85.4m0-65C236.1 20.4 12.4 244 12.4 519.9s223.7 499.5 499.6 499.5c275.9 0 499.6-223.7 499.6-499.5C1011.5 244 787.9 20.4 512 20.4z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 512,
    cy: 731.2,
    r: 32.6,
    transform: "rotate(-22.5 511.975 731.153)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M512 260c-81.3 0-147.4 66.1-147.4 147.4 0 18.2 14.8 33.1 33.1 33.1s33.1-14.8 33.1-33.1c0-44.8 36.4-81.2 81.2-81.2s81.2 36.4 81.2 81.2-36.4 81.2-81.2 81.2c-18.2 0-33.1 14.8-33.1 33.1v95.2c0 18.2 14.8 33.1 33.1 33.1s33.1-14.8 33.1-33.1V551l3.7-1c31-8 59.1-26.4 79.1-51.8 10-12.7 17.8-26.8 23.1-42 5.5-15.7 8.3-32.1 8.3-48.9.1-81.2-66-147.3-147.3-147.3z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaqWhite);
export default ForwardRef;